import { useMemo, useContext } from 'react';
import { tryParseJson } from '@jbhi-fi/utils/src/JSON/tryParseJson';
import { useCartContext } from '../../../utils/cart/context/CartContext';
import { useCustomerContext } from '@jbhi-fi/components/src/context/CustomerContextProvider';
import { CartCoupon } from '../types';
import { mapCartCouponToCoupon } from '../utils';
import { CouponProviderContext } from '../CouponContextProvider';

export const useManuallyAppliedCouponContext = () => {
  const context = useContext(CouponProviderContext);
  if (!context) throw new Error('useManuallyAppliedCouponContext must be used within a CouponProvider');
  const { coupons } = context;
  const { cart } = useCartContext();
  const { isLoggedIn = false } = useCustomerContext();

  const manuallyAppliedCoupons = useMemo(() => {
    const appliedCoupons = tryParseJson<Array<CartCoupon>>(cart?.attributes?._coupons) || [];
    const couponHandles = coupons.map(coupon => coupon.couponReference);

    return mapCartCouponToCoupon(appliedCoupons, couponHandles, isLoggedIn);
  }, [cart?.attributes?._coupons, isLoggedIn, coupons.length]);

  return {
    manuallyAppliedCoupons,
  };
};
